import { CommonModule } from "@angular/common";
import { Component, Input, OnInit, EventEmitter, Output } from "@angular/core";
import { Observable, Subscription } from "rxjs";

@Component({
  selector: "app-device-template",
  templateUrl: "./device-template.component.html",
  styleUrls: ["./device-template.component.scss"],
  standalone:true,
  imports:[CommonModule]
})
export class DeviceTemplateComponent implements OnInit {
  private eventsSubscription: Subscription;
   @Input() assetOrientation: string = "vertical";
  @Input() model: any;
  @Input() events: Observable<void>;
  @Output() eventHandler: EventEmitter<Object> = new EventEmitter<Object>();
  @Output() buttonClickHandler: EventEmitter<Object> =
    new EventEmitter<Object>();

  public primarydevice = "";
  public imgSrc = "";
  public img2src = "";
  public selectedAssetType = "";
  public selectedDrivenAssetType = "";
  public statusoftheasset = "";
  public datatoprocess: any;
  public seqCounter = 1;
  public subAssetType: string = "";



  constructor() {}

  ngOnInit(): void {
    this.datatoprocess = this.model;
    // console.log(this.model);
    // console.log(this.datatoprocess,'datatoprocess');
    //console.log(this.datatoprocess.secondary.device,"data to process secondry in device template");
    this.sequenciesOfSensors();
    this.plottemplate();
    this.subAssetType = this.datatoprocess.primary.device;
    if(this.subAssetType === "INDUCTION_MOTOR" || this.subAssetType === "DC_MOTOR" || this.subAssetType === "SYNCHRONOUS_MOTOR" || this.subAssetType === "ALTERNATOR"){
      this.selectedAssetType = "MOTOR";
    }else{
      this.selectedAssetType = this.datatoprocess.primary.device;
    }
    this.selectedDrivenAssetType = this.datatoprocess.secondary.device;
    this.eventsSubscription = this.events.subscribe((data) =>
      this.parentActivityEvent(data)
    );
  }
  ngAfterViewInit() {
    this.eventHandler.emit({ action: "loaded", value: this.seqCounter - 1 });
    this.buttonClickHandler.emit({
      id: "",
      device: this.selectedAssetType,
      subDevice: this.subAssetType,
      parent: "primary",
      sensor: this.datatoprocess.primary.master,
      sensorDetails:
        this.datatoprocess.primary.sensors[this.datatoprocess.primary.master],
    });
  }
  ngOnDestroy() {
    this.eventsSubscription.unsubscribe();
  }

  parentActivityEvent(data: any) {
    switch (data.action) {
      case "next":
        break;
      case "link_asset":
        this.updateSensor(
          data.keyname,
          data.value,
          data.parent,
          data.macAddress,
          data.assetid
        );
        break;
      case "done":
        data.values.array.forEach((element) => {
          this.updateSensor(
            element.keyname,
            element.value,
            element.parent,
            element.macAddress,
            element.assetid
          );
        });
        this.eventHandler.emit({
          action: "sensor_update",
          value: this.datatoprocess,
        });
        break;
    }
  }

  updateSensor(
    keyName: string,
    value: number,
    parent: string,
    mac_address: string,
    assetid: number
  ) {
    let sensors = this.datatoprocess[parent].sensors;
    Object.keys(sensors).forEach((key) => {
      if (sensors[key][keyName] === value) {
        sensors[key]["data-mac"] = mac_address;
        sensors[key]["id"] = assetid;
      }
    });
  }

  sequenciesOfSensors() {
    this.seqCounter = 1;
    if(this.datatoprocess != undefined || this.datatoprocess !=null){
      if (
        this.datatoprocess?.primary?.sensors[this.datatoprocess.primary.master].use
      ) {
        this.datatoprocess.primary.sensors[
          this.datatoprocess.primary.master
        ].label = this.seqCounter;
        this.datatoprocess.primary.sensors[this.datatoprocess.primary.master].bg =
          "#FFB3B3";
        this.seqCounter++;
      }
      Object.keys(this.datatoprocess?.primary?.sensors).forEach((key) => {
        if (
          key !== this.datatoprocess.primary.master &&
          this.datatoprocess.primary.sensors[key].use
        ) {
          this.datatoprocess.primary.sensors[key].label = this.seqCounter;
          this.datatoprocess.primary.sensors[key].bg = "#C4DFAA";
          this.seqCounter++;
        }
      });
      if (this.datatoprocess.secondary.device !== "") {
        Object.keys(this.datatoprocess.secondary.sensors).forEach((key) => {
          if (this.datatoprocess.secondary.sensors[key].use) {
            this.datatoprocess.secondary.sensors[key].label = this.seqCounter;
            this.datatoprocess.secondary.sensors[key].bg = "#C4DFAA";
            this.seqCounter++;
          }
        });
      }
    }
  }

  plottemplate() {
    // console.log(this.datatoprocess.primary.device,'this.datatoprocess.primary.device');
    this.plotforprimarydevice(this.datatoprocess.primary.device);
    this.plotforSecondarydevice(this.datatoprocess.secondary.device);
  }

  onclicksensor(
    event: any,
    device: string,
    parent: string,
    sensor: string,
    sensorDetails: any
  ) {
    this.buttonClickHandler.emit({
      id: event.target.id,
      device: device,
      parent: parent,
      sensor: sensor,
      sensorDetails: sensorDetails,
    });
  }
  plotforSecondarydevice(value) {
    console.log(value,'plotforSecondarydevice');
    switch (value.toLowerCase()) {
      case "motor":
        this.datatoprocess.secondary.device = this.selectedDrivenAssetType =
          "MOTOR";
        this.img2src = "./assets/motor_n.png";
        break;
      case "gear":
        this.datatoprocess.secondary.device = this.selectedDrivenAssetType =
          "GEAR";
        this.img2src = "./assets/gearbox.png";
        break;
      case "pump":
        this.datatoprocess.secondary.device = this.selectedDrivenAssetType =
          "PUMP";
        this.img2src = "./assets/pump.png";
        break;
      case "fan_blower":
        this.datatoprocess.secondary.device = this.selectedDrivenAssetType =
          "FAN_BLOWER";
        this.img2src = "./assets/fan.png";
        break;
      case "compressor":
        this.datatoprocess.secondary.device = this.selectedDrivenAssetType =
          "COMPRESSOR";
        this.img2src = "./assets/compressor.png";
        break;
      case "journal_bearing":
        this.datatoprocess.secondary.device = this.selectedDrivenAssetType =
          "JOURNAL_BEARING";
        this.img2src = "./assets/bearing2.png";
        break;
    }
  }
  plotforprimarydevice(value) {
    console.log(value,'primary')
    switch (value.toLowerCase()) {
      // case "motor":
      //   this.datatoprocess.primary.device = "MOTOR";
      //   this.imgSrc = "./assets/motor_n.png";
      //   break;
      case "induction_motor":
        this.datatoprocess.primary.device = "INDUCTION_MOTOR";
        this.imgSrc = "./assets/motor_n.png";
        break;
      case "dc_motor":
        console.log('dc_motor')
        this.datatoprocess.primary.device = "DC_MOTOR";
        this.imgSrc = "./assets/motor_n.png";
        break;
      case "synchronous_motor":
        this.datatoprocess.primary.device = "SYNCHRONOUS_MOTOR";
        this.imgSrc = "./assets/motor_n.png";
        break;
      case "alternator":
        this.datatoprocess.primary.device = "ALTERNATOR";
        this.imgSrc = "./assets/motor_n.png";
        break;
      case "gear":
        this.datatoprocess.primary.device = "GEAR";
        this.imgSrc = "./assets/gearbox.png";
        break;
      case "pump":
        this.datatoprocess.primary.device = "PUMP";
        this.imgSrc = "./assets/pump.png";
        break;
      case "fan_blower":
        this.datatoprocess.primary.device = "FAN_BLOWER";
        this.imgSrc = "./assets/fan.png";
        break;
      case "compressor":
        this.datatoprocess.primary.device = "COMPRESSOR";
        this.imgSrc = "./assets/compressor.png";
        break;
      case "journal_bearing":
        this.datatoprocess.primary.device = "JOURNAL_BEARING";
        // this.imgSrc = './assets/compressor.png';
        this.imgSrc = "./assets/bearing2.png";
        break;
    }
  }
}
